import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export function AuthRedirect() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
        <div className="w-full max-w-sm rounded-2xl bg-white p-6 text-center shadow-xl">
          <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-4 border-[#E91E8C]/20 border-t-[#E91E8C]" />
          <h1 className="text-lg font-semibold text-[#2d2d2d]">Comprobando sesión</h1>
          <p className="mt-2 text-sm text-gray-600">Espera un momento.</p>
        </div>
      </div>
    );
  }

  return <Navigate to={isAuthenticated ? '/dashboard' : '/'} replace />;
}
